import {
  REQUEST_RESULTS,
  RECEIVE_RESULTS,
  INVALIDATE_RESULTS
} from '../actions/ResultsActions';

const PropsInitialState = {
  items: []
};

const mergeNewResults = (oldRes, newRes) => {
  // dedup. The back-end search is not 100% consistent, there is some randomness.
  // so there is sometimes a repeat result.
  // And that messes up the player because it searches tracks by id.
  // So as a quick fix, remove dups.
  const oldIds = oldRes.map(track => track.id);
  const dedupedNewRes = newRes.filter(track => {
    return !oldIds.includes(track.id);
  });

  return [...oldRes, ...dedupedNewRes];
};

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
  case REQUEST_RESULTS: {
    return Object.assign({}, state, {
      isFetching: true,
      didEraseLastState: action.eraseLastState,
      didInvalidate: false
    });
  }
  case RECEIVE_RESULTS: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      items: mergeNewResults(state.items, action.items),
      lastUpdated: action.receivedAt,
      totalPages: parseInt(action.totalPages, 10)
    });
  }
  case 'RECEIVE_NEW_RESULTS': {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      items: action.items,
      hasFinished: false,
      lastUpdated: action.receivedAt,
      totalPages: parseInt(action.totalPages, 10)
    });
  }
  case INVALIDATE_RESULTS: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: true,
      items: [],
      receivedAt: Date.now(),
      totalPages: 0,
    });
  }
  default:
    return state;
  }
}

function ResultsReducer(state = PropsInitialState, action) {
  switch (action.type) {
  case REQUEST_RESULTS:
  case RECEIVE_RESULTS:
  case 'RECEIVE_NEW_RESULTS':
  case INVALIDATE_RESULTS: {
    return Object.assign({}, state, posts(state, action));
  }
  default: {
    return state;
  }
  }
}

export {
  ResultsReducer
};


// WEBPACK FOOTER //
// ./src/reducers/ResultsReducer.js